import styled from 'styled-components'
import { Link } from 'react-router-dom'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const SectionContainer = styled.div``

export const SectionTitle = styled.div`
  padding: 4px 8px;
  box-sizing: border-box;

  color: var(--foreground-neutral-faded, #4d5874);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;

  user-select: none;
`

export const RowContainer = styled(Link)`
  text-decoration: none;

  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  padding: 4px 8px;
  box-sizing: border-box;

  border-radius: 4px;
  border: 1px solid var(--border-neutral-faded, #fff);
  background: var(--background-elevation-base, #fff);

  cursor: pointer;

  :hover {
    border: 1px solid var(--border-neutral-faded, #f3f4f6);
    background: var(--background-elevation-base, #f3f4f6);
  }

  &.active {
    border: 1px solid var(--border-neutral-faded, #f3f4f6);
    background: var(--background-elevation-base, #f3f4f6);
  }
`

export const RowIconContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 16px;
  height: 16px;
`

export const RowIcon = styled.img``

export const RowLabel = styled.div`
  color: var(--foreground-neutral, #14171f);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;

  flex: 1;

  white-space: nowrap;
  overflow: hidden; /* Ajoutez cette ligne */
  text-overflow: ellipsis;

  max-width: 160px;
`

export const MoreButton = styled.div`
  display: flex;
  width: 20px;
  height: 16px;
  padding: 0px 2px;
  justify-content: center;
  align-items: center;

  border-radius: 3px;

  :hover {
    background: var(--background-neutral, #dfe2ea);
  }
`

export const MoreIconImg = styled.img`
  width: 16px;
  height: 16px;
`

export const DeleteIconImg = styled.img`
  width: 16px;
  height: 16px;
`
